module.exports = __webpack_public_path__ + "static/img/barcode4.b488707.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/state-ui/barcode4.gif
// module id = TQ4y
// module chunks = 1